import { sleep } from 'modules/Utils';
import Cookies from 'modules/Cookies';
import AnimationHelper from 'modules/AnimationHelper';
import { checkCurrentLocationIsOkinawa } from '../modules/Helpers';
import {
  MapSharedNewest,
  MapSharedOfficial,
  MapSharedPopular,
} from '../modules/API';
import tmpls from '../modules/HandlebarsTemplates';
import { isSmartPhone } from '../modules/DeviceOptions';

// Okinawa 特集バナー表示 ============================
const pickupSlider = $('.pickupSlider');

const checkOkinawaBanner = async () => {
  checkOkinawaAccount();

  const isInOkinawa = await checkCurrentLocationIsOkinawa();
  if (!isInOkinawa) {
    return;
  }

  addOkinawaBanner();
};

const checkOkinawaAccount = async () => {
  // check setCustomCookies
  if (!Cookies.get('session')) {
    // user is not logged in
    return;
  }

  while (!window.Gdata.Profile.ori) {
    await sleep(1000);
  }

  if (
    window.AS.setCustomCookies.isinokinawa.indexOf(
      window.Gdata.Profile.ori._id
    ) < 0
  ) {
    return;
  }

  addOkinawaBanner();
};

const addOkinawaBanner = async () => {
  while (!pickupSlider.data('init')) {
    await sleep(1000);
  }

  if (!$('.okinawaPickupSlide').length) {
    const currentSlide = pickupSlider.slick('slickCurrentSlide');
    pickupSlider.slick(
      'slickAdd',
      '<a class="pickupSlide okinawaPickupSlide" href="/naha-bus-station.php"></a>',
      currentSlide
    );
    pickupSlider.slick('slickNext');
  }

  renderOkinawaMapCard();
};

const renderOkinawaMapCard = () => {
  const targetCard = $('.storeMapListContainer').children(
    '.storeMapCard:eq(6)'
  );

  if (targetCard.length < 1) {
    return setTimeout(() => {
      renderOkinawaMapCard();
    }, 300);
  }

  if (!$('.okinawaMapCard').length) {
    targetCard.after(
      '<a class="okinawaMapCard" href="/naha-bus-station.php" style="display:block;"><img src="/img/tmp/okinawaSpecials.jpg" alt="沖縄マップ特集" style="width: 100%;"/></a>'
    );
  }
};

checkOkinawaBanner();

window.animateStoreMapListContainer = AnimationHelper(
  '.storeMapListContainer > .storeMapCard',
  {
    visiblePercent: 30,
  }
);

// Search History ==================================
const initSearchHistory = () => {
  const container = $('.searchHistoryContainer');

  if (!window.localStorage) {
    // no localStorage
    container.hide();
    return;
  }

  const lsHistoryKey = 'searchHistory';
  const lsSessionKey = 'searchHistorySession';

  // check session
  const shSession = localStorage.getItem(lsSessionKey) || '';
  const cSession = Cookies.get('session') || '';
  if (shSession !== cSession) {
    localStorage.removeItem(lsHistoryKey);
    localStorage.setItem(lsSessionKey, cSession);
  }

  // get history
  let searchHistory = localStorage.getItem(lsHistoryKey);
  if (searchHistory) {
    try {
      searchHistory = JSON.parse(searchHistory);
    } catch (error) {
      console.log(error);
    }
  }

  searchHistory = Array.isArray(searchHistory) ? searchHistory : [];

  const url = new URL(window.location.href);
  const keyword = url.searchParams.get('keyword');

  if (keyword) {
    searchHistory.unshift(keyword);
    searchHistory = _.uniq(searchHistory).splice(0, 5);
    localStorage.setItem(lsHistoryKey, JSON.stringify(searchHistory));
  }

  if (!searchHistory.length) {
    container.remove();
    return;
  }

  searchHistory.forEach((searchKeyword, index) => {
    container.append(
      `<a class="ellipsis searchHistoryItem${index}" href="/search_maps.php?keyword=${searchKeyword}">${searchKeyword}</a>`
    );
  });

  const filterSearchHistory = (filterKeyword) => {
    let hasFilteredItem = false;
    searchHistory.forEach((searchKeyword, index) => {
      if (
        searchKeyword.indexOf(filterKeyword) === 0 &&
        searchKeyword !== filterKeyword
      ) {
        $(`.searchHistoryItem${index}`).show();
        hasFilteredItem = true;
      } else {
        $(`.searchHistoryItem${index}`).hide();
      }
    });

    if (hasFilteredItem) {
      container.removeClass('hidden');
    } else {
      container.addClass('hidden');
    }
  };

  // add event handler
  $(document).on(
    'change keyup',
    '.sharedMapSearchInput',
    ({ currentTarget: { value } }) => {
      filterSearchHistory(value);
    }
  );

  $(document).on('focus', '.sharedMapSearchInput', () => {
    container.addClass('focused');
  });

  $(document).on('blur', '.sharedMapSearchInput', () => {
    container.removeClass('focused');
  });
};
initSearchHistory();

// =================================================

// windows
const {
  historyObj,
  langDic,
  CONFIG_ARR,
  animateStoreMapListContainer,
} = window;

let skip = 0;
const mapLimit = 20;
let paginationContainer = $('#paginationContainer');
const container = $('.storeMapListContainer');
const noResultCard = $('#sharedMapListNoResultCard');
const countLabel = $('.shareMapCountLabel');
const template = window.Handlebars.compile($('#StoreMapCardTemplate').html());
const categoryTemplate = window.Handlebars.compile($('#categoryTemplate').html());
const loading = $('#indexPageLoadingContainer');

const initSlider = async () => {
  // SLIDER
  const slider = $('.pickupSlider');

  if (!slider.length || !tmpls.SliderMapDescTemplate) {
    return;
  }

  slider.css('visibility', 'visible');
  slider.on('init', () => {
    slider.data('init', true);
  });
  slider.slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 6000,
  });

  //retrieve sliderMaps
  if (!window.SliderMaps) {
    return;
  }

  const idList = window.SliderMaps.map((map) => {
    return map._id;
  });

  if (!idList.length) {
    return;
  }

  try {
    const { maps } = await getAPI()({
      ids: idList,
      locale: window.hlocale,
    });

    maps.forEach((map) => {
      const pickupSlide = $(`.slideDescContainer${map._id}`);
      pickupSlide.css(
        'background',
        `url("${window.ImageDomainURLRead}${map.image_id}%3Fsize%3D1080") no-repeat`
      );
      pickupSlide.css('background-size', 'cover');
      pickupSlide.css('background-position', 'center');

      pickupSlide.append(tmpls.SliderMapDescTemplate(map));
    });
  } catch (error) {
    console.log(error);
  }
};

const getRestData = () => {
  const url = new URL(window.location.href);

  let keyword;
  if (url.searchParams.get('keyword')) {
    keyword = url.searchParams.get('keyword');

    const key = _.findKey(langDic, (value) => {
      return value === keyword;
    });
    if (key) {
      keyword = key;
    }
  }

  const category = url.searchParams.get('category');
  const prefecture = url.searchParams.get('prefecture');

  return {
    skip,
    limit: mapLimit,
    categories: category ? [category] : undefined,
    keyword,
    prefectures: prefecture ? [prefecture] : undefined,
    locale: window.hlocale,
    template_id:
      url.searchParams.get('type') === 'event'
        ? window.MapClass.template.aliasMap
        : undefined,
    template_id_new:
      url.searchParams.get('type') === 'event'
        ? window.MapClass.template.spotCollectionMap
        : undefined,
  };
};

const getAPI = () => {
  const url = new URL(window.location.href);
  const type = url.searchParams.get('type');
  if (type === 'popular') {
    return MapSharedPopular;
  } else if (type === 'official') {
    return MapSharedOfficial;
  }

  return MapSharedNewest;
};

export const checkAdsence = async () => {
  var adsConfig = false;
  await $.getJSON( window.location.origin + '/js/config/adsense.json', {
    format: "json"
  })
    .done(function( data ) {
      if ( typeof data.adsenses.top !== 'undefined' && data.adsenses.top.display == 'true') {
        adsConfig = data.adsenses.top;
      }
    }).catch(() => false);
  return adsConfig; 
};
checkAdsence().then(function(result){
  window.checkAdsenceTop =result;
});

const retrieveSharedMaps = async (count = 0) => {
  container.html('');
  noResultCard.hide();
  loading.show();
  paginationContainer.hide();

  const data = getRestData();
  if (count) {
    data.count = count;
  }
  data.not_special_contents = ['hide-in-map-life'];

  // if (data.categories || data.prefectures || data.keyword) {
  //   data.force_show_account_ids = [
  //     '59a8358ab92fc626f2295731',
  //     '5a939fdd5eb4a5699bfe3270'
  //   ];
  // }

  const result = await getAPI()(data);

  const { maps } = result;

  window.PopulateReplyCount(maps);

  const url = new URL(window.location.href);
  const showRanking = url.searchParams.get('type') === 'popular';
  let pos = -1;
  let iTop = 1;
  if (window.checkAdsenceTop && window.checkAdsenceTop.space) {
    pos = window.checkAdsenceTop.space[0];
  } 
  if (showRanking) {
    container.append(categoryTemplate);
  }
  maps.forEach((map, i) => {
    if((i == pos) && window.checkAdsenceTop) {
      if (window.checkAdsenceTop.space[iTop] != undefined) {
        pos = i + window.checkAdsenceTop.space[iTop];
        iTop++;
      } else {
        pos = i + window.checkAdsenceTop.space[iTop - 1];
      }
      var adsBanner = `<div><ins class="adsbygoogle"
                        style="display:inline-block;max-width:546px;min-height:90px;max-height:110px;width:100%;height:100%;"
                        data-ad-client="ca-pub-7001947114355359"
                        data-ad-slot="9322350545"></ins>
                        <script>
                          (adsbygoogle = window.adsbygoogle || []).push({});
                        </script>
                      </div>
                      `;
      container.append(adsBanner);
    }
    if (showRanking) {
      map.ranking_index = i + 1 + skip;
    }

    // check category
    let cat = url.searchParams.get('category');
    if (!(cat && CONFIG_ARR.map.categories[cat]) && map.categories) {
      cat = map.categories.find((innerCat) => {
        return innerCat.lcategory;
      });
      cat = cat && cat.lcategory;
    }

    if (cat && CONFIG_ARR.map.categories[cat]) {
      if (CONFIG_ARR.map.categories[cat].showChildCategoryInIndexPage) {
        // show child category
        const childCat = map.categories.find((innerChildCat) => {
          return (
            CONFIG_ARR.map.categories[cat].childCategories.indexOf(
              innerChildCat.category
            ) >= 0
          );
        });

        map.cat_obj = childCat && {
          color: CONFIG_ARR.map.categories[cat].color,
          category: childCat.category,
        };
      } else {
        map.cat_obj = {
          color: CONFIG_ARR.map.categories[cat].color,
          category: cat,
        };
      }
    }

    container.append(template(map));
  });

  if (animateStoreMapListContainer) {
    animateStoreMapListContainer();
  }

  loading.hide();
  paginationContainer.show();

  return result;
};

const loadIndexPageMaps = async () => {
  const url = new URL(window.location.href);

  const pageType = url.searchParams.get('type') || '';

  $('.storeTab').removeClass('active');
  $(`.storeTabType${pageType}`).addClass('active');

  // CONFIG
  if (url.searchParams.get('keyword')) {
    $('.sharedMapSearchInput').val(url.searchParams.get('keyword'));
    $('.sharedMapSearchInput').trigger('change');
  }

  // Parse
  let paginationFirstTime = true;
  const startPage = url.searchParams.get('page') || 1;
  skip = (startPage - 1) * mapLimit;

  paginationContainer.html('');

  try {
    const { count } = await retrieveSharedMaps(1);

    if (!count) {
      noResultCard.show();
      return;
    }

    countLabel.html(count + window.resolveLang('個のマップが公開中！'));

    //======================================
    //PAGINATION
    //======================================
    //Populate Pagination and Map Cards
    $('#paginationContainer').twbsPagination({
      totalPages: Math.ceil(count / mapLimit),
      startPage: parseInt(startPage, 10),
      visiblePages: 7,
      first: '«',
      last: '»',
      async onPageClick(event, page) {
        event.preventDefault();

        if (paginationFirstTime) {
          paginationFirstTime = false;
          return;
        }

        skip = (page - 1) * mapLimit;

        // handle history and analytics
        if (historyObj) {
          const obj = historyObj.getUrlData({
            parseQuery: true,
            setQuery: {
              page,
            },
          });
          historyObj.pushHistoryState(obj.url);
        }

        // scroll to top
        let scrollTop = 0;
        let duration = 0;
        if (!isSmartPhone) {
          if ($('.pickupContianer').length) {
            scrollTop = $('.pickupContianer').outerHeight();
          }
          duration = 300;
        }
        $('html, body').animate(
          {
            scrollTop,
          },
          duration
        );

        await retrieveSharedMaps();
      },
    });
  } catch (error) {
    console.log(error);
  }
};

$(document).ready(() => {
   if (sessionStorage.getItem('firstTime') == null && Cookies.get('session') && !MobileDevice.IsMobile ) {
    sessionStorage.setItem('firstTime','false');
     setTimeout(() => {
          window.location.href = '/profile/';
        }, 2000);
  } else {
    setTimeout(() => {
      window.NativeHideSplash();
    }, 300);
   initSlider();

    window.APIGetAllUserData({
      force: true,
      always() {},
    });

    // configure search bar
    if (isSmartPhone) {
      $('.mapSearchOpenSearchModal').show();
    } else {
      $('.searchContainer').show();
    }

   
    loadIndexPageMaps();
  }
});

// ===========================
// SP
$('.storeTab').on('click', (e) => {
  const mapType = $(e.currentTarget).data('type');

  /**
   * twbsPagination('destroy') にバグがあるため以下の方法で対応する
   */
  // paginationContainer.twbsPagination('destroy');
  paginationContainer.remove();
  $('.middlePane').append(
    '<div id="paginationContainer" class="paginationContainer"></div>'
  );
  paginationContainer = $('#paginationContainer');

  if (historyObj) {
    const obj = historyObj.getUrlData({
      parseQuery: true,
      setQuery: {
        type: mapType,
        page: 1,
      },
    });
    historyObj.replaceHistoryState(obj.url);
  }

  $('.checkTypeQuery').each((index, elm) => {
    const url = new URL(`${window.location.origin}${$(elm).attr('href')}`);
    if (mapType) {
      url.searchParams.set('type', mapType);
    } else {
      url.searchParams.delete('type');
    }

    $(elm).attr('href', `${url.pathname}${url.search}`);
  });

  loadIndexPageMaps();
});
